import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import MinistriesPage from './pages/MinistriesPage';
import MinistryAreasPage from './pages/MinistryAreasPage';
import MembersPage from './pages/MembersPage';
import GroupsPage from './pages/GroupsPage';
import MemberInvolvementsPage from './pages/MemberInvolvementsPage';
import MemberInvolvementsEditPage from './pages/MemberInvolvementsEditPage';
import InvolvementsPage from './pages/InvolvementsPage';
import UsersPage from './pages/UsersPage';
import ProfilePage from './pages/ProfilePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const theme = createTheme({
  palette: {
    primary: { main: '#1a237e' },
    secondary: { main: '#3949ab' },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="ministries" element={<MinistriesPage />} />
              <Route path="ministry-areas" element={<MinistryAreasPage />} />
              <Route path="members" element={<MembersPage />} />
              <Route path="groups" element={<AdminRoute><GroupsPage /></AdminRoute>} />
              <Route path="members/:id/preferences" element={<MemberInvolvementsPage />} />
              <Route path="members/:id/preferences/edit" element={<AdminRoute><MemberInvolvementsEditPage /></AdminRoute>} />
              <Route path="users" element={<AdminRoute><UsersPage /></AdminRoute>} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="preferences/ministries/:ministryId/ministry-areas/:ministryAreaId" element={<InvolvementsPage />} />
              <Route path="preferences/ministries/:ministryId" element={<InvolvementsPage />} />
              <Route path="preferences" element={<InvolvementsPage />} />
            </Route>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
